export default (message) => { throw new Error(message) }
